define.alias("shared/utils/delete-media-item", "settings/utils/delete-media-item");